import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { COMPANY_TYPE } from 'app/mock/mock-company-type-list';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { SpinnerService } from 'app/services/spinner.service';
import { UserService } from 'app/services/user/user.service';

@Component({
  selector: 'ms-profile-company',
  templateUrl: './profile-company.component.html',
  styleUrls: ['./profile-company.component.css'],
  encapsulation: ViewEncapsulation.None,
    host: {
        "[@fadeInAnimation]": 'true'
    },
    animations: [ fadeInAnimation ]
})
export class ProfileCompanyComponent implements OnInit {

  submitted = false;
  error = false;
  success = false;
  companyDetailForm: FormGroup;
  registerId: any;
  getCompanyData: any;
  checkIfUserAlreadyExist = false;
  confirmPasswordCheck = false;
  companyTypeList = [];

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();

    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.MY_PROFILE_COMPANY")

    this.companyDetailForm = this.companyDetailFormBuilder(this.formBuilder);

    this.companyTypeList = COMPANY_TYPE;

    this.userService.getCompanyDetail().subscribe(data => {
      console.log(data);
      this.getCompanyData = data;
      this.companyDetailForm = this.companyDetailFormBuilder(this.formBuilder);
      this.spinnerService.stop();
    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.companyDetailForm.controls; }
  // convenience getter for easy access to form fields
  get val() { return this.companyDetailForm.value; }

  // form builder service create form group instances
  companyDetailFormBuilder = (formBuilder: FormBuilder) => {
    return formBuilder.group({
      businessName: [this.getCompanyData && this.getCompanyData.businessName ? this.getCompanyData.businessName : '', [Validators.required]],
      vatNumber: [this.getCompanyData && this.getCompanyData.vatNumber ? this.getCompanyData.vatNumber : '', [Validators.required, Validators.pattern('^\\d{11}$')]],
      typeOfCompany: [this.getCompanyData && this.getCompanyData.typeOfCompany ? this.getCompanyData.typeOfCompany : '', [Validators.required]],
      businessEmail: [this.getCompanyData && this.getCompanyData.businessEmail && this.getCompanyData.businessEmail.email ? this.getCompanyData.businessEmail.email : '', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      companyPec: [this.getCompanyData && this.getCompanyData.businessEmailPec && this.getCompanyData.businessEmailPec.email ? this.getCompanyData.businessEmailPec.email : '', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      companyResidenceVia: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.street ? this.getCompanyData.address.street : '', [Validators.required]],
      companyResidenceNCivic: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.houseNumber ? this.getCompanyData.address.houseNumber : '', [Validators.required]],
      companyResidenceCity: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.city ? this.getCompanyData.address.city : '', [Validators.required]],
      companyResidenceProvince: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.district ? this.getCompanyData.address.district : '', [Validators.required]],
      companyResidenceCountry: [this.getCompanyData && this.getCompanyData.address && this.getCompanyData.address.country ? this.getCompanyData.address.country : '', [Validators.required]]
    });
  }

  onSubmit() {
    this.spinnerService.start();
    this.submitted = true;
    this.success = false;
    this.error = false;

    if (this.companyDetailForm.invalid) {
      this.commonUtilService.findInvalidControls(this.companyDetailForm);
      this.spinnerService.stop();
      return;
    }

    var companyDetail = {
      businessName: this.val.businessName,
      vatNumber: this.val.vatNumber,
      typeOfCompany: this.val.typeOfCompany,
      businessEmail: {
        email: this.val.businessEmail
      },
      businessEmailPec: {
        email: this.val.companyPec
      },
      address: {
        street: this.val.companyResidenceVia,
        houseNumber: this.val.companyResidenceNCivic,
        city: this.val.companyResidenceCity,
        district: this.val.companyResidenceProvince,
        country: this.val.companyResidenceCountry
      }
    };

    this.userService.saveCompanyDetail(companyDetail).subscribe(data => {
      this.success = true;
      this.spinnerService.stop();
      setTimeout(function () {
        location.reload();
      }, 2000); 
    }, err => {
      this.error = true;
      this.spinnerService.stop();
      setTimeout(()=>{                           
        this.error = false;
      }, 2000); 
    });
  }

  resetForm(){
    this.companyDetailForm = this.companyDetailFormBuilder(this.formBuilder);
  }
}
